import React, { ReactElement, useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import reCaptcha from 'utils/reCaptcha';
import Contact from 'sections/Company/ContactUsPage/components/Contact';
import RootLayout from 'layouts/RootLayout';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import Breadcrumbs from 'components/Breadcrumbs';

interface ISetting {
  name?: string;
  email?: string;
  phone?: string;
  subject: string | Array<string>;
  addressVisible?: boolean;
  platform: string;
  modal?: boolean;
  timer?: string;
  paddingDisable?: boolean;
  small?: boolean;
}

export default function ContactUsPage() {
  const [{ user }] = useCookies(['user']);
  const root = useRef<HTMLDivElement>(null);
  const { logged } = useSelector((state: RootState) => state.userData);

  let contact: ISetting = {
    subject: ['IT Service', 'Logistics Service', 'Digital Freight Alliance', 'Other'],
    platform: 'df-alliance',
    addressVisible: true,
  };

  if (logged) contact = { ...contact, ...{ name: user?.name, email: user?.email, phone: user?.phone } };

  useEffect(() => {
    reCaptcha();
  }, []);

  return (
    <section ref={root} className="contact__wrapper">
      <div className="container">
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Contact Us', href: '' }]} />

        <div className="contactApp">
          <Contact contact={contact} />
        </div>
      </div>
    </section>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Get in Touch with DF Alliance | DF Alliance',
      description: 'Contact DF Alliance to get in touch with their expert team for inquiries, support, and assistance with global logistics solutions and freight forwarding needs.',
      path: '/company/contact-us',
    },
  };
};

ContactUsPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
